<template>
  <div>
    <cabecalho
      title="FINANCEIRO.CONTATO"
      title_type="modal"
      :btnPrimary="true"
      btnPrimaryText="GERAL.ADICIONAR"
      @primary-method="abrirFecharForm"
    />

    <div v-if="formulario.exibir" class="row">
      <div class="col-12">
        <input-text
          ref="nome"
          v-model="formulario.dados.nome"
          :label="$t('FINANCEIRO.NOME_CONTATO')"
          :placeholder="$t('FINANCEIRO.NOME_CONTATO')"
          :maxLength="60"
        />
      </div>
      <div class="col-12">
        <input-text
          ref="descricao"
          v-model="formulario.dados.descricao"
          :label="$t('FINANCEIRO.CONTATO')"
          :placeholder="$t('FINANCEIRO.CONTATO_PLACEHOLDER')"
          :maxLength="60"
        />
      </div>

      <div class="col-12 mb-4">
        <b-button variant="primary" @click="adicionarContato">
          {{ $t('FINANCEIRO.ADICIONAR_CONTATO') }}
        </b-button>
      </div>
    </div>

    <!-- Tabela -->
    <b-table
      :fields="fields"
      :items="contatos"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      head-variant="light"
      stacked="md"
      responsive
      show-empty
      striped
      hover
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default">
          <b-dropdown-item @click="excluirContato(item)">
            {{ $t('FINANCEIRO.EXCLUIR_CONTATO') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>
<script>
// Components:
import { Cabecalho } from '@/components/headers';
import { InputText } from '@/components/inputs';

import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

export default {
  props: {
    contatos: { type: Array, default: Array },
  },
  components: {
    Cabecalho,
    InputText,
  },
  data() {
    return {
      formulario: {
        exibir: false,
        dados: {},
      },
      fields: [
        {
          key: 'nome',
          label: this.$t('FINANCEIRO.NOME_CONTATO'),
          sortable: true,
        },
        {
          key: 'descricao',
          label: this.$t('FINANCEIRO.CONTATO'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('FINANCEIRO.ACOES'),
        },
      ],
    };
  },
  methods: {
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    adicionarContato() {
      if (!this.validarFormulario()) return;
      this.contatos.push(this.formulario.dados);
      this.formulario.dados = {};
      this.formulario.exibir = false;
      this.$emit('atualiza-form', 'contatos', this.contatos);
    },
    async excluirContato(item) {
      const respostaExclusao = await mensagem.confirmacao(
        null,
        this.$t('FINANCEIRO.CONFIRMAR_EXCLUIR_CONTATO')
      );
      if (respostaExclusao.isConfirmed) {
        this.$emit('excluir', item);
      }
    },

    abrirFecharForm() {
      this.formulario.exibir = !this.formulario.exibir
    },
  },
};
</script>
